<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">
            <router-link to="/apps/stickers" class="navbar-brand text-center">
              <strong> <i class="fas fa-chevron-left"></i> Back </strong>
            </router-link>
            <span>Edit Sticker</span>
          </h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="mt-2 float-md-right float-left">
            <ol class="breadcrumb mb-0 justify-content-end p-0">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/apps/stickers">Stickers</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ stickerId }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->

    <div class="page-content container-fluid" v-if="stickerId">
      <div class="card">
        <div class="card-body">
          <form @submit.prevent="updateStickerDetail">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Active</label>
              <div class="col-sm-10 pt-2">
                  <input type="checkbox" v-model="editStickerForm.active" />
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Sticker image</label>
              <div class="col-sm-10">
                <img width="80" :src="editStickerForm.image" v-if="editStickerForm.image">
                <input type="file" class="form-control" @change="onChangeSticker" accept="image/*" :required="!editStickerForm.image" />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Name</label>

              <div class="col-sm-10">
                <input type="text" class="form-control" v-model="editStickerForm.name" required />
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Button URL</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" v-model="editStickerForm.buttonUrl" required />
              </div>
            </div>
            
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <div class="col-sm-2"></div>
              <div class="col-sm-10">
                <StickerTab :currentCondition="editStickerForm.currentCondition" @updateCurrentCondition="updateCurrentCondition" />
              </div>
            </div>

            <div class="form-group row" v-show="editStickerForm.currentCondition === 'rule'">
              <label class="col-sm-2 col-form-label">Rule</label>
              <div class="col-sm-10">
                <textarea
                  type="text"
                  class="form-control"
                  v-model="editStickerForm.rule"
                  rows="5"
                />
              </div>
            </div>

            <div class="form-group row" v-show="editStickerForm.currentCondition === 'emails'">
              <label class="col-sm-2 col-form-label">User Emails</label>
              <div class="col-sm-10">
                <span><i>Needs to be separated by a newline.</i></span>
                <textarea
                  placeholder="example@example.com
example02@example@example.com"
                  type="text"
                  class="form-control"
                  v-model="editStickerForm.emails"
                  rows="5"
                />
              </div>
            </div>

            <div class="form-group row" v-show="editStickerForm.currentCondition === 'userIds'">
              <label class="col-sm-2 col-form-label">User Ids</label>
              <div class="col-sm-10">
                <span><i>Needs to be separated by a newline.</i></span>
                <textarea
                  placeholder="123
456"
                  type="text"
                  class="form-control"
                  v-model="editStickerForm.userIds"
                  rows="5"
                />
              </div>
            </div>
            
            <div class="form-group text-center">
              <button class="btn btn-primary btn-sm" type="button" @click="backToStickerList">Cancel</button>
              <button
                class="btn btn-primary btn-sm"
                type="submit"
                style="margin-left: 10px"
              >Save changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import StickerApi from '@/api/sticker'
import utils  from "@/utils"
import StickerTab from './StickerTab.vue';

export default {
  data() {
    return {
      stickerId: null,
      isUpdatingSticker: false,
      editStickerForm: {
        name: '',
        image: '',
        rule: '',
        buttonText: '',
        buttonUrl: '',
        text: '',
        active: '',
        userId: null,
        emails: '',
        userIds: '',
        currentCondition: null,
      },
      conditions: ['rule', 'emails', 'userIds'],
    };
  },
  components: {
    StickerTab,
  },
  mounted() {
    this.stickerId = this.$route.params.id;
    this.getStickerDetail(this.stickerId);
  },
  methods: {
    async getStickerDetail(id) {
      const data = await StickerApi.getStickerDetail(id);
      this.editStickerForm.name = data.name;
      this.editStickerForm.image = data.image;
      this.editStickerForm.text = data.text;
      this.editStickerForm.buttonText = data.buttonText;
      this.editStickerForm.buttonUrl = data.buttonUrl;
      this.editStickerForm.active = data.active;
      this.editStickerForm.rule = data.rule;
      this.editStickerForm.userId = data.userId;
      this.editStickerForm.emails = data.emails.replace(',', '\n');
      this.editStickerForm.userIds = data.userIds.replace(',', '\n');
      this.editStickerForm.currentCondition = data.currentCondition;
    },
    async onChangeSticker(event) {
      let file = event.target.files[0]
      if (!file) {
        this.editStickerForm = {
          ...this.editStickerForm,
          image: '',
        }
        return
      }
      this.isUpdatingSticker = true
      let formData = new FormData()
      formData.append("file", file)
      const imageUrl = await StickerApi.uploadStickerImage(formData)
      this.isUpdatingSticker = false
      this.editStickerForm.image = imageUrl
    },
    updateStickerForm () {
      this.conditions.forEach(condition => { 
        this.editStickerForm[condition] = this.editStickerForm.currentCondition === condition ? this.editStickerForm[condition] : ''; 
      }); 
    },
    async updateStickerDetail() {
      if (this.isUpdatingSticker) return
      this.isUpdatingSticker = true
      try {
        this.updateStickerForm()
        await StickerApi.updateSticker(this.stickerId, this.editStickerForm)
        utils.showToastSuccess("Sticker updated!")
      } catch (e) {
        utils.showToastError(e.message || 'Something went wrong')
      } finally {
        this.isUpdatingSticker = false
      }
    },
    async deleteStickerDetail() {
      try {
        await StickerApi.deleteSticker(this.stickerId)
        utils.showToastSuccess("Sticker deleted!");
      } catch (e) {
        utils.showToastError(e.bodyText);
      }
    },
    backToStickerList() {
      this.$router.push({
        name: 'Stickers'
      })
    },
    updateCurrentCondition(value) {
      this.editStickerForm.currentCondition = value
    }
  },
};
</script>

<style lang="scss" scoped>
</style>